import React from "react";
import {GlobalAlertContextConsumer} from "./GlobalAlertContextProvider";
import AlertBadge from "./AlertBadge";

class ChecklistAlertBadge extends React.Component<any, any> {
  public render() {
    return (
      <GlobalAlertContextConsumer>
        {(globalAlertContextState) => {
          return (
            <AlertBadge count={globalAlertContextState.checklist.alertCount} />
          );
        }}
      </GlobalAlertContextConsumer>
    );
  }
}

export default ChecklistAlertBadge;


// WEBPACK FOOTER //
// ./src/app/alert/ChecklistAlertBadge.tsx